<template>
  <v-col cols="12" md="3" lg="2" class="p-2" @click="toggle">
    <v-card
      class="file-card d-flex flex-column justify-center align-center"
      :class="{ selected: image.selected }"
      elevation="2"
    >
      <div class="d-flex justify-end align-end w-100">
        <v-checkbox
          v-model="image.selected"
          color="success"
          @click.stop="$emit('toggle')"
          hide-details
        />
      </div>

      <v-img
        :src="icon"
        contain
        max-width="60"
        max-height="60"
        class="mx-auto"
      />

      <span class="file-title"> {{ image.title }}.{{ extension }} </span>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "PdfFileCard",
  props: {
    image: {
      type: Object,
      required: true,
    },
    salon: {
      type: Object,
      required: true,
    },
    getFileIcon: {
      type: Function,
      required: true,
    },
  },
  computed: {
    extension() {
      return this.image?.path?.split(".").pop();
    },
    icon() {
      return this.getFileIcon(this.image.path);
    },
  },
  methods: {
    toggle() {
      this.$emit("select", this.image);
    },
  },
};
</script>

<style scoped>
.file-card {
  padding: 16px 8px;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: all 0.25s ease;
  border: 2px solid transparent;
}

.file-card.selected {
  border-color: #1abc9c !important;
  box-shadow: 0 0 12px rgba(26, 188, 156, 0.45) !important;
}

.file-title {
  display: block;
  margin-top: 8px;
  font-weight: bold;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
}
</style>
